import Style from "./style"
import caution500 from "./asset/caution500.svg"

const InternalServerError = () => {

    return (
        <Style.WrapperDiv>
            <Style.CautionSvg src={caution500} />
            <Style.Title>죄송합니다.</Style.Title>
            <Style.Content>현재 서버가 점검 중일 수 있으니, 관리자에게 문의해 주세요.</Style.Content>
        </Style.WrapperDiv>
    )
}

export default InternalServerError